import React from "react";
import { motion } from "framer-motion";
import { Building2, Globe2, Users2, Award } from "lucide-react";

const STATS = [
  { icon: Building2, n: "500+", l: "Companies Incorporated" },
  { icon: Globe2, n: "40+", l: "Countries Represented" },
  { icon: Users2, n: "1,200+", l: "Visas & Residencies" },
  { icon: Award, n: "98%", l: "Bank Account Approval Rate" },
];

export default function StatsStrip({ variant = "light" }) {
  const dark = variant === "dark";
  return (
    <section
      data-testid="stats-strip"
      className={`relative ${dark ? "bg-[#0A1128] text-white" : "bg-white text-[#0F172A]"} border-y ${dark ? "border-white/10" : "border-slate-200"}`}
    >
      <div className="container-x py-10 md:py-14 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
        {STATS.map(({ icon: Icon, n, l }, i) => (
          <motion.div
            key={l}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="flex items-start gap-4 md:justify-center md:text-left"
          >
            <div
              className={`shrink-0 w-11 h-11 rounded-sm border inline-flex items-center justify-center ${
                dark ? "border-white/20 text-[#6B8AFF]" : "border-[#3366FF]/30 text-[#3366FF]"
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={1.75} />
            </div>
            <div>
              <div className="font-heading font-black text-3xl md:text-4xl tracking-tight leading-none">
                {n}
              </div>
              <div
                className={`mt-1.5 text-xs md:text-sm ${
                  dark ? "text-slate-300/80" : "text-slate-600"
                }`}
              >
                {l}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
